module.exports = __webpack_public_path__ + "static/media/DHT.2af5cacf.svg";